import React, { memo } from "react";
// import IndiaFactoryMap from "./components/factoryMapGraph";
// import BreakdownByBGChart from "./components/barGraph";
import OrTrendChart from "./components/orTrendChart";
import ORLossDetailsCard from "./components/donutChart";
import HeatMapTable from "./components/orHeatMap";
import "./orLossTreeContainer.css";
import RMTable from "./components/rmTable";

export const OrLossTreeContainer = memo(({ viewType, exportORTrendChart, exportHeatmap }) => {
  return (
    <div className="orLoss-page-wrapper relative">
      <div className="orLoss-container">
        <div className="content-wrapper">
          {/* <div className="mid-section">  Hiding it as per requirement (05/12/2025)
            <div className="factory">
              <div style={{ height: '250px', width: "100%" }}>
                <IndiaFactoryMap tblView={viewType}/>
              </div>
            </div>
            <div className="bar-graph">
              <div style={{ height: "330px", width: "100%" }}>
                <BreakdownByBGChart tblView={viewType}/>
              </div>
            </div>
          </div> */}

          <OrTrendChart tblView={viewType} exportORTrendChart={exportORTrendChart}/>
          <div className="last-section">
            <div className="doughnut-chart" st={{ pt: 0 }}>
              <ORLossDetailsCard tblView={viewType} />
            </div>
            <div className="heat-map" style={{ paddingBottom: 0 }}>
              <HeatMapTable tblView={viewType} exportHeatmap={exportHeatmap}/>
            </div>
          </div>
          <div className="rm-table-orLossTree">
            <RMTable tblView={viewType} />
          </div>
        </div>
      </div>
    </div>
  );
});
